export const setClass = (...classes: string[]) => classes.join(' ')
